export { IWlComponentCanDeactivateRoute } from './icomponent-can-deactivate-route';
export { WlCanDeactivateRouteGuard } from './can-deactivate-route-guard';
